// import { addOrUpdateElement } from '../helpers'
import { Security } from '../securities/reducer'
import { AlertsAction } from './actions'
import {
  CancelOrderAlert,
  CounteredToppedAlert,
  NewOrderAlert,
  TradingNowAlert
} from './types'

export interface State {
  tradingNowAlerts: Record<number, TradingNowAlert>
  counteredToppedAlerts: Record<string, CounteredToppedAlert>
  newOrderAlerts: Record<string, NewOrderAlert>
  cancelOrderAlerts: Record<string, CancelOrderAlert>
  mutedAlerts: {
    tradingNow: Array<Security['id']>
    countered: Array<Security['id']>
    topped: Array<Security['id']>
    newOrder: Array<Security['id']>
    cancelOrder: Array<Security['id']>
  }
}

export const initialState: State = {
  tradingNowAlerts: {},
  counteredToppedAlerts: {},
  newOrderAlerts: {},
  cancelOrderAlerts: {},
  mutedAlerts: {
    tradingNow: [],
    countered: [],
    topped: [],
    newOrder: [],
    cancelOrder: []
  }
}

const reducer = (state = initialState, action: AlertsAction) => {
  switch (action.type) {
    case 'alerts.addTradingNowAlerts':
      const newTradingNow = { ...state.tradingNowAlerts }
      action.payload.tradingNowAlerts.forEach((a) => (newTradingNow[a.id] = a))
      return {
        ...state,
        tradingNowAlerts: newTradingNow
      }

    case 'alerts.addCounteredToppedAlerts':
      const newCounteredTopped = { ...state.counteredToppedAlerts }
      action.payload.counteredToppedAlerts.forEach(
        (a) => (newCounteredTopped[a.id] = a)
      )
      return {
        ...state,
        counteredToppedAlerts: newCounteredTopped
      }
    case 'alerts.addNewOrderAlerts':
      const newAlerts = { ...state.newOrderAlerts }
      action.payload.newOrderAlerts.forEach((a) => (newAlerts[a.id] = a))

      // cut the amount of alerts kept in redux to the most recent 300
      const limitedResults = Object.fromEntries(
        Object.entries(newAlerts).splice(-300)
      )

      return {
        ...state,
        newOrderAlerts: limitedResults
      }

    case 'alerts.addCancelOrderAlerts':
      const newCancelOrders = { ...state.cancelOrderAlerts }
      action.payload.cancelOrderAlerts.forEach(
        (a) => (newCancelOrders[a.id] = a)
      )
      return {
        ...state,
        cancelOrderAlerts: newCancelOrders
      }
    case 'alerts.muteAlert':
      return {
        ...state,
        mutedAlerts: {
          ...state.mutedAlerts,
          [action.payload.alertType]: [
            ...state.mutedAlerts[action.payload.alertType],
            action.payload.securityId
          ]
        }
      }

    case 'alerts.unmuteAlert':
      return {
        ...state,
        mutedAlerts: {
          ...state.mutedAlerts,
          [action.payload.type]: state.mutedAlerts[action.payload.type].filter(
            (id) => id !== action.payload.securityId
          )
        }
      }

    default:
      return state
  }
}

export default reducer
